import { RequestorIdentity } from "../types/requestorIdentity.ts";

export function makeRequestorIdentityDefault(
  userName?: string,
): null | RequestorIdentity {
  if (typeof userName !== "string" || userName === "") {
    return null;
  }

  return {
    requestor: {
      userReference: {
        userName,
        userRoleType: "LoggedInUser",
      },
    },
  };
}
